import { Component, OnInit} from '@angular/core';
import { User } from '../_models/user';
import { AuthenticationService } from '../authentication.service';
import { Router} from '@angular/router';
import { DamserviceService } from "../dam/damservice.service";
import { OrganisationService } from "../create-organisation/organisation.service";
import { AuthService } from "angularx-social-login";

@Component({
  selector: 'app-allworkspaces',
  templateUrl: './allworkspaces.component.html',
  styleUrls: ['./allworkspaces.component.css']
})
export class AllworkspacesComponent implements OnInit {

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private damService: DamserviceService,
    private authService: AuthService,
    private organisationService: OrganisationService,
  ) { }

  currentUser: User;
  mobileView: boolean = false;
  planName: String;
  ownerEmail: String;
  ownerName: String;
  invitedUsersList = [];
  usersRoles = [];
  workspaceId: any
  workspaceName: string;
  workspaces = [];
  workspaceNameDynamic: string;
  totalSpaceAllowed: any;
  consumedSpaceAllowed: any;
  totalSpaceAllowedProgress: any;
  userRole: string;


  ngOnInit(): void {
    this.authenticationService.currentUser.subscribe(x => { this.currentUser = x });
    if (window.screen.width <= 991) { // 768px portrait
      this.mobileView = true;
    }else{
      this.mobileView = false;

    }
  }

  getWorkspaceDetails(){
    var details = JSON.parse(localStorage.getItem('workspaceDetails'));
    this.workspaceId = details.workspaceId;
    this.workspaceName = details.workspaceName;
    // this.userRole = details.userRole;
    this.listWorkspace();
  }

  listWorkspace(){
    if (this.currentUser) {
      this.organisationService.getWorkspaceList().subscribe((data: any) => {
        if(data.length > 0){
          this.workspaces = data;
          this.workspaceId = data[0].id;
          this.workspaceName = data[0].title;
          this.workspaceNameDynamic = data[0].title;
          this.userRole = data[0].role;
          this.ownerListApi(this.workspaceId);
        }else{
          this.router.navigate(['/create-workspace']);
        }
        });
      }else{
        this.router.navigate(['/login']);
      }
    }

  ownerListApi(workspaceId: any){
    this.damService.getOwnerList(workspaceId).subscribe((data: any) => {
      this.ownerEmail = data.email;
      this.planName = data.plan_title;
      this.ownerName = data.first_name + " " + data.last_name;
      this.totalSpaceAllowed = data.allowed_dam_space_kb/1000000
      this.consumedSpaceAllowed = data.current_dam_space/1000
      this.totalSpaceAllowedProgress = data.allowed_dam_space_kb/1000
    });
  }

  switchToWorkspace(){
    window.scrollTo(0, 0);
    // this.selectedMembershipBuyNow = membership;
    if (this.currentUser) {
      this.router.navigate(['/dam']);
    }
  }

  personalClick(){
    this.router.navigate(['/dam/personal']);
  }

  logOut(): void {
    this.authenticationService.logout();
    this.authService.signOut();
    this.router.navigate(['/home']);
  }

  goToMarketplace() {
    window.open("https://crafttor.com/marketplace", "_blank");
  }

  goToFeedback() {
    window.open("https://workspace.crafttor.com/feedbacks", "_blank");
  }
}
